import { EMPTY_LIST } from '../../../../constants/common'

export function getEmptyItemActions() {
  return EMPTY_LIST
}
